import { useFormik } from 'formik';
import { Box } from './UI-CHAKRA/Box';
import { Button } from './UI-CHAKRA/Button';
import { Flex } from './UI-CHAKRA/Flex';
import { Text } from './UI-CHAKRA/Text';

interface CancelPrescriptionProps {
  onClose(): void;
  confirmText: string;
  cancelText: string;
  onConfirm(reason: string): void;
  onCancelCallback?(): void;
  disableCancel?: boolean;
}

export function CancelPrescription({ disableCancel = false, ...props }: CancelPrescriptionProps) {
  const formik = useFormik({
    validateOnChange: true,
    initialValues: {
      reason: '',
    },
    onSubmit: (values) => {
      props.onConfirm(values.reason);
    },
  });

  const handleOnCancel = () => {
    props.onClose();
    if (props.onCancelCallback && !disableCancel) {
      props.onCancelCallback();
    }
  };

  return (
    <form onSubmit={formik.handleSubmit} style={{ width: '100%' }}>
      <Box h={'100%'}>
        <Box pb={'8px'}>
          <Text fontSize={'18px'} fontWeight={700} align={'center'}>
            Deseja cancelar esta receita?
          </Text>
        </Box>
        <Flex w={'100%'} justifyContent={'center'} mt={'10px'}>
          <Button
            p={'9px 24px'}
            variant={'ghost'}
            color={'typography.darkest'}
            bg={'gray.lightest'}
            boxShadow={'none'}
            fontWeight={400}
            fontSize={'15px'}
            mr={'5px'}
            h={'40px'}
            onClick={handleOnCancel}
          >
            {props.cancelText}
          </Button>

          <Button
            p={'9px 24px'}
            fontSize={'15px'}
            fontWeight={'600'}
            color={'#BF0711'}
            bg={'#FBEAE5'}
            w={'146px'}
            h={'40px'}
            variant={'ghost'}
            type={'submit'}
          >
            {props.confirmText}
          </Button>
        </Flex>
      </Box>
    </form>
  );
}
